module.exports = __webpack_public_path__ + "static/bruno-close-min-1f9082f5916ad6db84e980624984018b.jpg";